var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"product-list"},[_c('swiper',{ref:"mySwiper",staticClass:"product-list-body",attrs:{"options":_vm.swiperOption}},_vm._l((_vm.items),function(it,id){return _c('div',{key:id},_vm._l((it),function(item,index){return _c('index-product-body',{key:index,attrs:{"item":item,"index":index}})}),1)}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }